import React from 'react';
import { Link } from 'react-router-dom';

const AstroDailyPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-4 mb-8">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between">
            <Link to="/astrodaily" className="flex items-center gap-2 text-purple-600 hover:text-purple-800 transition-colors font-medium">
              <span>← Retour à AstroDaily</span>
            </Link>
            <h1 className="text-xl font-bold text-gray-900">Politique de Confidentialité</h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="prose prose-gray prose-lg max-w-none">
            {/* Title Section */}
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Politique de Confidentialité
              </h1>
              <p className="text-xl text-gray-600">
                AstroDaily - Infinity Cloud
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>

            {/* Privacy Policy Content */}
            <section className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
                <p>
                  Chez AstroDaily by Infinity Cloud, nous prenons votre vie privée très au sérieux. 
                  Cette politique de confidentialité explique comment nous collectons, utilisons et 
                  protégeons vos informations personnelles lorsque vous utilisez notre service d'horoscope 
                  quotidien.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">2. Données Collectées</h2>
                <p>
                  AstroDaily fonctionne de manière anonyme et ne collecte aucune donnée personnelle 
                  identifiable. Nous ne demandons pas :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Votre nom ou prénom</li>
                  <li>Votre adresse email</li>
                  <li>Votre date de naissance exacte</li>
                  <li>Votre localisation géographique</li>
                  <li>Aucune information de connexion ou d'inscription</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">3. Utilisation des Données</h2>
                <p>
                  Les seules données que nous utilisons sont :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>
                    <strong>Signe astrologique sélectionné</strong> : Stocké temporairement dans votre 
                    navigateur (localStorage) pour mémoriser votre préférence
                  </li>
                  <li>
                    <strong>Statistiques anonymes</strong> : Nombre de visites par page, sans aucune 
                    information permettant de vous identifier
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">4. Stockage Local</h2>
                <p>
                  Nous utilisons le stockage local de votre navigateur (localStorage) uniquement pour :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Mémoriser votre signe astrologique préféré</li>
                  <li>Sauvegarder vos préférences de langue (FR/EN)</li>
                </ul>
                <p className="mt-3">
                  Ces données restent sur votre appareil et ne sont jamais transmises à nos serveurs.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">5. Cookies</h2>
                <p>
                  AstroDaily n'utilise aucun cookie de suivi ou de publicité. Nous n'utilisons que 
                  des cookies techniques essentiels au fonctionnement du site :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Cookies de session pour la navigation</li>
                  <li>Aucun cookie tiers</li>
                  <li>Aucun cookie publicitaire</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">6. Partage des Données</h2>
                <p>
                  Nous ne vendons, ne louons et ne partageons jamais vos données avec des tiers. 
                  AstroDaily est un service gratuit sans publicité et sans monétisation de données.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">7. Sécurité</h2>
                <p>
                  Nous utilisons les meilleures pratiques de sécurité :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Connexion HTTPS sécurisée</li>
                  <li>Infrastructure hébergée en Suisse</li>
                  <li>Aucune base de données utilisateur</li>
                  <li>Code source régulièrement audité</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">8. Vos Droits</h2>
                <p>
                  Comme nous ne collectons aucune donnée personnelle, vous avez le contrôle total :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Effacez les données locales à tout moment via les paramètres de votre navigateur</li>
                  <li>Utilisez le mode privé/incognito pour une session sans traces</li>
                  <li>Aucune donnée à supprimer sur nos serveurs car nous n'en stockons aucune</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">9. Modifications</h2>
                <p>
                  Nous nous réservons le droit de modifier cette politique de confidentialité. 
                  Toute modification sera affichée sur cette page avec une nouvelle date de mise à jour.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">10. Contact</h2>
                <p>
                  Pour toute question concernant cette politique de confidentialité ou notre service :
                </p>
                <div className="mt-4 p-4 bg-gray-100 rounded-lg">
                  <p className="font-semibold">Infinity Cloud</p>
                  <p className="text-gray-600">Email : contact@infinity-cloud.ch</p>
                  <p className="text-gray-600">Site : <a href="https://infinity-cloud.ch" className="text-purple-600 hover:text-purple-800">infinity-cloud.ch</a></p>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gradient-to-r from-purple-100 to-blue-100 rounded-xl border border-purple-200">
                <h3 className="text-xl font-bold mb-3 text-purple-800">Notre Engagement</h3>
                <p className="text-purple-700">
                  AstroDaily s'engage à rester un service gratuit, sans publicité et respectueux 
                  de votre vie privée. Votre confiance est notre priorité absolue.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-8 mt-20">
        <div className="container mx-auto px-6 text-center">
          <p className="text-gray-600">
            © {new Date().getFullYear()} Infinity Cloud. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AstroDailyPrivacy;